import React, {useEffect} from "react";
import {Modal} from "semantic-ui-react";
import {useRiskUploadSelector} from "../../../../../store/selectors/project.selectors";
import {subsManager} from "../../../../../store/middleware/subs-manager/subs-manager";
import { zoomies, waveform } from 'ldrs'
zoomies.register()
waveform.register()


export default function RiskUploadModal(props: {
    riskUploadId: string;
    setShowUploadModal: (show: boolean) => void;
}) {
    const riskUpload = useRiskUploadSelector();

    useEffect(() => {
        subsManager.subscribeRiskUpload(props.riskUploadId);
    }, [props.riskUploadId]);

    const closeHandler = () => {
        props.setShowUploadModal(false);
        subsManager.removeSubscription('risk-upload')
    }

    const returnContentByStatus = (status: string) => {
        switch (status) {
            case "pending":
                return <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    // gap: '10px',
                }}>
                    <l-zoomies
                        size="600"
                        stroke="10"
                        bg-opacity="0.1"
                        speed="1.4"
                        color="black"
                    ></l-zoomies>
                    <h5>The risk register upload is pending. This may take a few moments.</h5>
                    </div>;
            case "processing":
                return <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    // gap: '10px',
                }}>
                    <l-waveform
                        size="35"
                        stroke="3.5"
                        speed="1"
                        color="black"
                    ></l-waveform>
                    <h5>{`${riskUpload?.message || ""}`}</h5>
                </div>
            case "complete":
                return <h5>The risk register has been successfully uploaded.</h5>;
            case "error":
                return <p>{riskUpload?.message || 'There has been an error processing this file'}</p>;
            default:
                return <p>Unknown status.</p>;
        }
    }

    return (
        <Modal open closeIcon onClose={closeHandler}>
            <Modal.Header>Upload Risk Register</Modal.Header>
            <Modal.Content>
                {riskUpload ? returnContentByStatus(riskUpload.status) : <p>Loading...</p>}
            </Modal.Content>
            <Modal.Actions>
                <button className="ui button primary" onClick={closeHandler}>Close</button>
            </Modal.Actions>
        </Modal>
    );
}